/**
 * API helpers for the Career Advisor memory dashboard.
 */

import { getCSRFToken } from "./advisor_api"

function headers() {
  return {
    "Content-Type": "application/json",
    "X-CSRF-Token": getCSRFToken(),
    Accept: "application/json"
  }
}

/**
 * Update a memory's content.
 * @param {string} url - The PATCH endpoint URL
 * @param {string} content - New content text
 * @returns {Promise<Object>}
 */
export async function updateMemory(url, content) {
  const response = await fetch(url, {
    method: "PATCH",
    headers: headers(),
    body: JSON.stringify({ content })
  })
  return response.json()
}

/**
 * Soft-delete a memory.
 * @param {string} url - The DELETE endpoint URL
 * @returns {Promise<Object>}
 */
export async function deleteMemory(url) {
  const response = await fetch(url, {
    method: "DELETE",
    headers: headers()
  })
  return response.json()
}

/**
 * Clear all memories for the current user.
 * @param {string} url - The POST clear endpoint URL
 * @returns {Promise<Object>}
 */
export async function clearAllMemories(url) {
  const response = await fetch(url, {
    method: "POST",
    headers: headers()
  })
  return response.json()
}
